import React from 'react';
import './EventTooltip.css';

const EventTooltip = ({ event, style }) => {
  if (!event) return null;
  
  const { title, extendedProps } = event;
  
  // Log the event data for debugging
  console.log('Event tooltip data:', event);
  console.log('Event extended props:', extendedProps);
  
  // Extract properties with fallbacks
  const description = extendedProps?.description || '';
  const location = extendedProps?.location || '';
  
  // Try different possible locations for creator name
  const creatorName = extendedProps?.creatorName || 
                     extendedProps?.creator || 
                     extendedProps?.createdBy || 
                     'Band Member';
  
  // Format the event time
  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  const startTime = formatTime(event.start);
  const endTime = formatTime(event.end);
  
  return (
    <div className="event-tooltip" style={style}>
      <h3>{title}</h3>
      {description && <p className="tooltip-description">{description}</p>}
      {location && <p className="tooltip-location">📍 {location}</p>}
      <p className="tooltip-time">⏰ {startTime} - {endTime}</p>
      <p className="tooltip-creator">👤 {creatorName}</p>
    </div>
  );
};

export default EventTooltip;
